export const combineLanguageAndScript = (language: string, script: string) =>
  `${language}-${script}`;

export const formatLocale = (language: string, market: string) => `${language}-${market}`;
